<template>
  <div class="viewmode-table">

    <header class="viewmode-table__header">
      <div class="left">
        <h1>{{ this.$Strings('tableTitle') }}</h1>
        <p>{{ this.$Strings('tableDescription') }}</p>
      </div>

      <div class="right download" v-if="downloadUrl">
        <a :href="downloadUrl" target="_blank" class="btn">Download displayed data</a>
        <a :href="this.$Strings('tableFullDatasetUrl')" target="_blank" class="btn">Download dataset</a>
      </div>
    </header>

    <section class="table">
      <range-year-slider :years="$store.state.defaultYears" :startSelection="dateRange"></range-year-slider>
      <TableChart :sortingKey="sortingKey" :showAttributes="showAttributes" v-if="data" :data="data" :showConfidenceInterval="true"></TableChart>
    </section>

  </div><!-- /.viewmode-table -->
</template>

<script>
// import axios from 'axios'
import _ from 'lodash'

import rangeYearSlider from '../shared/sliders/RangeYearSlider'
import TableChart from '../shared/charts/TableChart.vue'

// import {EventBus} from '@/event-bus.js'

export default {
  name: 'viewmode-table',
  props: {
    'data': {},
    'dateRange': {},
    'sortingKey': {
      default: 'ID_country_name',
      required: false
    },
    showAttributes: {
      type: Array
    }
  },
  components: { TableChart, rangeYearSlider },
  computed: {
    downloadUrl () {
      let countries = this.$store.state.rsc.selected
      let attributes = this.showAttributes
      let dateRange = this.$store.state.rangeYearSliderCurrent

      if (!countries || !attributes) {
        return false
      }

      return process.env.CSV_URL +
        '?rsc=' + _.map(countries, 'id').join(',') +
        '&attr=' + attributes.join(',') +
        '&year1=' + dateRange[0] +
        '&year2=' + dateRange[1]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';

  .viewmode-table__header{
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 40px;
  }
  .left{
    flex: 1 1 auto;
    margin: 0;

    > * { margin: 0; }
  }
  .right{
    flex: 0 0 170px;

    & > A{
      color: $gray-darkest;
      text-align: center;
      width: 170px;
    }
    & > A:first-child{
      margin-bottom: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/ViewModeTable.vue